import { render, staticRenderFns } from "./DetailsPassengersList.vue?vue&type=template&id=d1ed843e&"
import script from "./DetailsPassengersList.vue?vue&type=script&lang=ts&"
export * from "./DetailsPassengersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports